import React, { Component } from 'react';
import Header from '../components/header/Header';
import { Colors, StyledComponents, Metrics } from '../themes';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import AjaxActions from '../redux/AjaxRedux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import { Grid, Paper, Typography } from '@material-ui/core';
import clsx from 'clsx';
import SnackbarNotification from '../components/common/SnackbarNotification';
import DeviceComponent from '../components/ajaxElements/DeviceComponent';
import HubsTable from '../components/ajaxElements/HubsTable';
import LogsTable from '../components/ajaxElements/LogsTable';
import './Ajax.css';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

const { MainContentContainer, SpinningRefresh } = StyledComponents;

const styles = (theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.6em',
      backgroundColor: Colors.navBackgroundGrey,
    },
    '*::-webkit-scrollbar-thumb': {
      width: '0.6em',
      borderRadius: 10,
      background: Colors.hoverGrey,
    },
    '*::-webkit-scrollbar-track': {
      marginRight: 10,
    },
    '*::-webkit-scrollbar-corner': {
      background: 'rgba(0,0,0,0)',
    },
  },
  gridContainer: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: Metrics.contentGridMaxWidthXl.home,
    },
  },
  paper: {
    textAlign: 'center',
    background: Colors.hoverGrey,
    color: Colors.white,
    minHeight: 392,
    height: '100%',
  },
  paperLowerRow: {
    minHeight: Metrics.widgetMinHeight,
  },
  devices: {
    display: 'flex',
    flexDirection: 'column',
  },
  limitHeight: {
    maxHeight: 640,
    overflowY: 'auto',
  },
  widgetContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  title: {
    textAlign: 'left',
    padding: theme.spacing(4),
  },
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  titleRowTitle: {
    margin: 0,
    padding: 20,
  },
  refreshButtonsContainer: {
    margin: '10px 4px',
  },
});

const REFRESH_INTERVAL = 60; // interval in seconds

class Ajax extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSnackbarNotificationOpen: false,
      snackbarVariant: 'warning',
      snackbarMessage: '',
      selectedHubId: null,
      isAutoRefreshOn: false,
      timer: REFRESH_INTERVAL,
    };
    this.intervalTimer = null;
  }

  componentDidMount() {
    if (!this.props.userId && this.props.accessToken && this.props.customerId) {
      console.log('Ajax login componentDidMount');
      this.props.loginAjax(this.props.customerId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      accessToken,
      customerId,
      hasAjax,
      userId,
      loginAjax,
      ajaxErrorMessage,
      hubs,
      getHubs,
      getHubDetails,
      getDevices,
      getRooms,
      getLogs,
      getGroups,
      resetAjax,
    } = this.props;
    const { selectedHubId } = this.state;

    if (userId && userId !== prevProps.userId) {
      getHubs(customerId, userId);
    }
    if (hubs.length > 0 && hubs.length !== prevProps.hubs.length) {
      hubs.forEach((hub) => getHubDetails(customerId, userId, hub.hubId));
      hubs.forEach((hub) => getLogs(customerId, userId, hub.hubId));
      // if only one hub, select it automatically
      if (hubs.length === 1) {
        this.setState({ selectedHubId: hubs[0].hubId });
      }
    }
    // only if all hubs have details, get groups if groupsEnabled
    if (JSON.stringify(prevProps.hubs) !== JSON.stringify(hubs) && hubs.every((hub) => hub.hasDetails)) {
      console.log('All hubs have details. Get groups if groups enabled');
      const hubsWithGroupsEnabled = hubs.filter((hub) => hub.groupsEnabled);
      hubsWithGroupsEnabled.forEach((hub) => getGroups(customerId, userId, hub.hubId, hub.hubIndex));
    }
    // if hub selected, fetch devices
    if (selectedHubId && selectedHubId !== prevState.selectedHubId) {
      getRooms(customerId, userId, selectedHubId);
      getDevices(customerId, userId, selectedHubId);
    }
    // handle change of customer
    if (prevProps.hasAjax !== hasAjax) {
      // if no customerId or no permission, redirect to home
      if (!hasAjax) {
        console.log('redirect from Ajax to home at customer change');
        this.props.history.push('/');
        resetAjax();
      } else {
        console.log('login Ajax because of customer change');
        loginAjax(customerId);
      }
    }
    if (!prevState.isAutoRefreshOn && this.state.isAutoRefreshOn) {
      this.loopRefresh();
    } else if (prevState.isAutoRefreshOn && !this.state.isAutoRefreshOn) {
      clearInterval(this.intervalTimer);
      this.setState({ timer: REFRESH_INTERVAL });
    }
    // snackbarMessages
    if (prevProps.ajaxIsLoading && !this.props.ajaxIsLoading) {
      if (this.props.ajaxSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.ajaxSuccessMessage,
        });
      }
      if (this.props.ajaxErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.ajaxErrorMessage,
        });
      }
    }
  }

  refresh = () => {
    const { customerId, userId, hubs, resetHubDetails, getHubDetails, getLogs } = this.props;
    resetHubDetails();
    hubs.forEach((hub) => getHubDetails(customerId, userId, hub.hubId));
    hubs.forEach((hub) => getLogs(customerId, userId, hub.hubId));
  };

  loopRefresh = () => {
    this.intervalTimer = setInterval(() => {
      const timer = this.state.timer > 0 ? this.state.timer - 1 : REFRESH_INTERVAL;
      if (this.state.timer === REFRESH_INTERVAL) {
        this.refresh();
      }
      this.setState({ timer });
    }, 1000);
  };

  handleHubButtonClick = (command, hubId) => {
    const logsPageNumber = 1;
    this.props.armHub(this.props.customerId, this.props.userId, hubId, command, logsPageNumber);
  };
  handleGroupButtonClick = (isArmed, hubId, hubIndex, groupId) => {
    const command = isArmed ? 'DISARM' : 'ARM';
    const logsPageNumber = 1;
    this.props.armGroup(this.props.customerId, this.props.userId, hubId, hubIndex, groupId, command, logsPageNumber);
  };

  render() {
    const { classes, width, t } = this.props;
    const isLarge = width === 'lg' || width === 'xl';
    const groupData =
      this.props.groups && this.props.groups.length > 0
        ? this.props.groups.map((group) => {
            const parentHub = this.props.hubs.find((hub) => hub.id === group.hubId);
            let hubName = '';
            if (parentHub && parentHub.name) {
              hubName = parentHub.name;
            }
            return { ...group, name: group.groupName, hubName };
          })
        : [];

    return (
      <MainContentContainer className={classes.MainContentContainer}>
        <SnackbarNotification
          open={this.state.isSnackbarNotificationOpen}
          variant={this.state.snackbarVariant}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />
        <Header />
        <Grid container className={classes.gridContainer} spacing={isLarge ? 6 : 5}>
          <Grid item xs={12} md={6} xl={5}>
            <Paper className={clsx(classes.paper, classes.hubs, classes.limitHeight)}>
              <div className={classes.widgetContainer}>
                <div className={classes.titleRow}>
                  <Typography variant="h2" className={clsx(classes.label, classes.titleRowTitle)}>
                    {t('ajax.hubs')}
                  </Typography>
                  <div className={classes.refreshButtonsContainer}>
                    <FormControlLabel
                      className={classes.enableWidgetSwitch}
                      control={
                        <Switch
                          checked={this.state.isAutoRefreshOn}
                          onChange={(event) => this.setState({ isAutoRefreshOn: event.target.checked })}
                          value="isAutoRefreshOn"
                        />
                      }
                      label={t('ajax.autoRefresh')}
                      labelPlacement="start"
                    />
                    <IconButton key="refresh" aria-label="refresh" color="inherit" onClick={this.refresh}>
                      {this.props.isLoading ? <SpinningRefresh /> : <AutorenewIcon />}
                    </IconButton>
                  </div>
                </div>
                <HubsTable
                  isLoading={this.props.isLoading}
                  data={this.props.hubs}
                  activeRowField={'hubId'}
                  activeRowValue={this.state.selectedHubId}
                  handleSelectRow={(hubId) => {
                    this.setState({ selectedHubId: hubId });
                  }}
                  onButtonClick={(isArmed, hubId) => this.handleHubButtonClick(isArmed, hubId)}
                />
                <div className={classes.title}>
                  <Typography variant="h2" className={classes.label}>
                    {t('ajax.groups')}
                  </Typography>
                </div>
                <HubsTable
                  isLoading={this.props.isLoading}
                  data={groupData}
                  onButtonClick={(isArmed, hubId, hubIndex, groupId) => {
                    this.handleGroupButtonClick(isArmed, hubId, hubIndex, groupId);
                  }}
                  isGroups
                />
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} xl={7}>
            <Paper className={clsx(classes.paper, classes.devices, classes.limitHeight)}>
              <div className={classes.widgetContainer}>
                <div className={classes.title}>
                  <Typography variant="h2" className={classes.label}>
                    {t('ajax.devices')}
                  </Typography>
                  <div className="devicesContainer">
                    {this.state.selectedHubId ? (
                      this.props.devices.map((device) => (
                        <DeviceComponent key={device.id} device={device} rooms={this.props.rooms} />
                      ))
                    ) : (
                      <Typography className={classes.innerText}>{t('ajax.pleaseSelectAHubToShowDevices')}</Typography>
                    )}
                  </div>
                </div>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} xl={12}>
            <Paper className={clsx([classes.paper, classes.logs])}>
              <div className={classes.widgetContainer}>
                <div className={classes.titleRow}>
                  <Typography variant="h2" className={clsx(classes.label, classes.titleRowTitle)}>
                    {t('ajax.logs')}
                  </Typography>
                  <div className={classes.refreshButtonsContainer}>
                    <FormControlLabel
                      className={classes.enableWidgetSwitch}
                      control={
                        <Switch
                          checked={this.state.isAutoRefreshOn}
                          onChange={(event) => this.setState({ isAutoRefreshOn: event.target.checked })}
                          value="isAutoRefreshOn"
                        />
                      }
                      label={t('ajax.autoRefresh')}
                      labelPlacement="start"
                    />
                    <IconButton key="refresh" aria-label="refresh" color="inherit" onClick={this.refresh}>
                      {this.props.isLoading ? <SpinningRefresh /> : <AutorenewIcon />}
                    </IconButton>
                  </div>
                </div>
                <LogsTable logs={this.props.logs} />
              </div>
            </Paper>
          </Grid>
        </Grid>
      </MainContentContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    accessToken: state.auth.token,
    customerId: state.auth.customerId,
    customerIdSub: state.auth.customerIdSub,
    customers: state.customers.customers,
    isLoading: state.ajax.isLoading,
    hasAjax: state.auth.hasAjax,
    userId: state.ajax.userId,
    baseHubs: state.ajax.baseHubs,
    hubs: state.ajax.hubs,
    groups: state.ajax.groups,
    devices: state.ajax.devices,
    rooms: state.ajax.rooms,
    logs: state.ajax.logs,
    ajaxIsLoading: state.ajax.isLoading,
    ajaxSuccessMessage: state.ajax.successMessage,
    ajaxErrorMessage: state.ajax.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  loginAjax: (customerId) => dispatch(AjaxActions.loginAjaxRequest(customerId)),
  getHubs: (customerId, userId) => dispatch(AjaxActions.getHubsRequest(customerId, userId)),
  getHubDetails: (customerId, userId, hubId) => dispatch(AjaxActions.getHubDetailsRequest(customerId, userId, hubId)),
  resetAjax: () => dispatch(AjaxActions.resetAjax()),
  resetHubDetails: () => dispatch(AjaxActions.resetHubDetailsRequest()),
  getDevices: (customerId, userId, hubId) => dispatch(AjaxActions.getDevicesRequest(customerId, userId, hubId)),
  getRooms: (customerId, userId, hubId) => dispatch(AjaxActions.getRoomsRequest(customerId, userId, hubId)),
  getLogs: (customerId, userId, hubId) => dispatch(AjaxActions.getLogsRequest(customerId, userId, hubId)),
  getGroups: (customerId, userId, hubId, hubIndex) =>
    dispatch(AjaxActions.getGroupsRequest(customerId, userId, hubId, hubIndex)),
  armHub: (customerId, userId, hubId, command) =>
    dispatch(AjaxActions.armHubRequest(customerId, userId, hubId, command)),
  armGroup: (customerId, userId, hubId, hubIndex, groupId, command, logsPageNumber) =>
    dispatch(AjaxActions.armGroupRequest(customerId, userId, hubId, hubIndex, groupId, command, logsPageNumber)),
});

export default compose(
  withTranslation(),
  withStyles(styles),
  withRouter,
  withWidth(),
  connect(mapStateToProps, mapDispatchToProps)
)(Ajax);
